import React, { Suspense } from "react";
import { Route, Routes } from "react-router";
import { adminRoutes, authRoutes, employeeRoutes, publicRoutes } from "./router.link";
import Feature from "../feature";
import AuthFeature from "../authFeature";
import AdminFeature from "../adminFeature";
import PublicFeature from "../publicFeature";

const PageLoader = () => (
  <div className="d-flex align-items-center justify-content-center vh-100 bg-white">
    <div className="spinner-border text-primary" role="status" style={{ width: "2.5rem", height: "2.5rem" }}>
      <span className="visually-hidden">Loading...</span>
    </div>
  </div>
);

const ALLRoutes: React.FC = () => {
  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>

        <Route element={<PublicFeature />}>
          {publicRoutes.map((route, idx) => (
            <Route path={route.path} element={route.element} key={idx} />
          ))}
        </Route>

        <Route element={<AdminFeature />}>
          {adminRoutes.map((route, idx) => (
            <Route path={route.path} element={route.element} key={idx} />
          ))}
        </Route>

        <Route element={<Feature />}>
          {employeeRoutes.map((route, idx) => (
            <Route path={route.path} element={route.element} key={idx} />
          ))}
        </Route>

        <Route element={<AuthFeature />}>
          {authRoutes.map((route, idx) => (
            <Route path={route.path} element={route.element} key={idx} />
          ))}
        </Route>
      </Routes>
    </Suspense>
  );
};

export default ALLRoutes;
